// extracted by mini-css-extract-plugin
export default {"applicationItem":"users-form_applicationItem__-3jyK","applicationProduct":"users-form_applicationProduct__rtikh"};